import { useNavigate } from "react-router-dom";
import { ArrowRight, ChevronLeft, ChevronRight } from "lucide-react";
import { useRef } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { usePublicMenu } from "@/hooks/usePublicMenu";
import { useSessionContext } from "@/contexts/SessionContext";
import { Button } from "@/components/ui/button";

export default function CategoriesSection() {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const { session } = useSessionContext();
  const branchId = session.order.branchId;
  const { categories } = usePublicMenu(branchId);
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (dir: "left" | "right") => {
    scrollRef.current?.scrollBy({ left: dir === "left" ? -260 : 260, behavior: "smooth" });
  };

  if (categories.length === 0) return null;

  return (
    <section className="py-20 md:py-28 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="font-heading text-4xl md:text-6xl font-black text-foreground">
            {language === "ar" ? "استكشف قائمتنا" : "Explore Our Menu"}
          </h2>
          <div className="w-16 h-1 bg-primary mx-auto mt-4 rounded-full" />
        </div>

        <div className="relative">
          {/* Scroll arrows */}
          <button
            onClick={() => scroll("left")}
            className="absolute -start-4 top-1/2 -translate-y-1/2 z-10 hidden md:flex w-10 h-10 rounded-full border border-border bg-card shadow-md items-center justify-center text-muted-foreground hover:text-primary hover:border-primary/40 transition-colors">
            
            <ChevronRight className="w-5 h-5" />
          </button>
          <button
            onClick={() => scroll("right")}
            className="absolute -end-4 top-1/2 -translate-y-1/2 z-10 hidden md:flex w-10 h-10 rounded-full border border-border bg-card shadow-md items-center justify-center text-muted-foreground hover:text-primary hover:border-primary/40 transition-colors">
            
            <ChevronLeft className="w-5 h-5" />
          </button>

          <div
            ref={scrollRef}
            className="flex gap-5 overflow-x-auto pb-4 snap-x snap-mandatory"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}>
            
            {categories.map((cat) =>
            <button
              key={cat.id}
              onClick={() => navigate(`/menu?category=${cat.id}`)}
              className="group flex-shrink-0 w-[180px] md:w-[200px] snap-start">
              
                <div className="rounded-2xl overflow-hidden border border-border bg-card hover:border-primary/30 transition-all hover:shadow-xl">
                  <div className="aspect-square bg-muted flex items-center justify-center text-5xl">
                    {cat.icon || "🍽️"}
                  </div>
                  <div className="p-4 text-center bg-card">
                    <h3 className="font-heading font-bold text-foreground text-sm group-hover:text-primary transition-colors">
                      {language === "ar" ? cat.nameAr || cat.name : cat.name}
                    </h3>
                  </div>
                </div>
              </button>
            )}
          </div>
        </div>

        <div className="text-center mt-10">
          <Button
            className="rounded-md px-10 py-6 text-base font-bold bg-primary/10 text-primary border border-primary/30 hover:bg-primary hover:text-primary-foreground transition-all"
            onClick={() => navigate("/menu")}>
            
            {language === "ar" ? "عرض القائمة كاملة" : "View Full Menu"}
            <ArrowRight className="w-4 h-4 ms-2" />
          </Button>
        </div>
      </div>
    </section>);

}